module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pl-button default truncate-text",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-686f14e1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plButton/plButton.vue
// module id = 1244
// module chunks = 61